<template>
  <el-form-item
    prop="output"
    class="player-setup-display-output mt-8 mb-0">
    <el-select
      v-model="model.output"
      class="output-select is-centered"
      @change="$emit('change', model.output)">
      <el-option
        v-for="item in outputCountOptions"
        v-show="item.show"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>

    <p class="text-xs input-hint text-center mt-3">{{ $t('playerSetup.SelectNumberOfDisplays') }}</p>
  </el-form-item>
</template>

<script src="./player-setup-display-output.js"></script>
<style lang="scss" src="./player-setup-display-output.scss"></style>
